<script setup lang="ts">

import { ref } from 'vue';
import FaIcon from '@/application/components/ui/FaIcon.vue';
import { useBaseDataStore } from '@/user/store/baseDataStore.ts';
import { isNativePlatform } from '@/application/utils/envInfo';

const { duzen } = useBaseDataStore();

const infoText = ref(duzen(
  `Vertragsdaten einfach übernehmen lassen: Die Versicherungspolice hochladen
  ${isNativePlatform ? 'oder abfotografieren' : ''} und von der KI alle relevanten Informationen auslesen lassen. Danach
  kannst du das Ergebnis noch prüfen und mit einem Klick den Vertrag anlegen.
`,
  `Vertragsdaten einfach übernehmen lassen: Laden Sie Ihre Versicherungspolice hoch
  ${isNativePlatform ? 'oder fotografieren Sie sie ab' : ''}. Die KI liest alle wichtigen Informationen aus und
  füllt die Felder automatisch für Sie vor. Sie prüfen nur noch und legen den Vertrag mit einem Klick an.`
))

</script>

<template>
  <div class="flex flex-col gap-2 border border-gray-200 rounded-lg py-2 px-3 bg-white">
    <div class="flex gap-3 items-center">
      <span class="font-medium text-sm md:text-base text-gray-900">Neu: der KI-Assistent für Verträge</span>
      <FaIcon name="sparkles" variant="regular" class="text-blue-500 cursor-help" />
    </div>
    <p class="text-xs md:text-sm text-gray-800 mb-2">{{ infoText }}</p>
    <slot />
  </div>
</template>
